import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type ExtendedRootNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { introDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { proThumbnailComponent } from '@nodeTypeConfig/helpers/editComponents/proThumbnailComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
// Extends WEBPAGE2 => When adding GLOBAL_TRAININGSDATABASE WebConfig to a WEBPAGE2 it becomes "the" (there is only one) PRO_GLOBAL_DATABASE
export const PRO_GLOBAL_DATABASE: ExtendedRootNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [],
  information: {
    description: 'Pro Global database is just one page: the search page for all trainings',
    single: 'Globale professionaliseringsdatabank',
    plural: 'Globale professionaliseringsdatabank',
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  extends: NodeType.WEBPAGE2,
  tocTypes: [],
  buildingBlocks: [{ type: NodeType.SECTION }],
  edit: [
    titleComponent,
    introDescriptionComponent,
    {
      ...proThumbnailComponent,
      width: 6,
      label: 'Tegelfoto',
    },
    {
      ...authorsComponent,
      label: 'Themaverantwoordelijke',
    },
    publishComponent,
  ],
  audienceTab: proThemeAudienceTab,
  webTab: asideWebBasicConfiguration,
};
